var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.lockedCategory)?_c('icon',{attrs:{"name":"lock"}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }